import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsfix", "children", "onChange", "value"];
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prefix } from "../../wui-core/src/index.js";
var propTypes = {
  clsfix: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};
var defaultProps = {
  clsfix: "".concat(prefix, "-search-tabs"),
  onChange: function onChange() {}
};

var SearchTabs = /*#__PURE__*/function (_Component) {
  _inherits(SearchTabs, _Component);

  var _super = _createSuper(SearchTabs);

  function SearchTabs(props) {
    var _this;

    _classCallCheck(this, SearchTabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getChildren", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          clsfix = _this$props.clsfix;
      var childs = [];

      if (children.length > 1) {
        React.Children.map(children, function (child, index) {
          childs.push( /*#__PURE__*/React.cloneElement(child, {
            tabClick: _this.childClick,
            active: child.props.value == _this.state.activeValue,
            clsfix: clsfix
          }));

          if (index < children.length - 1) {
            childs.push( /*#__PURE__*/React.createElement("span", {
              className: "".concat(clsfix, "-split"),
              key: "split-".concat(index)
            }, "|"));
          }
        });
      } else {
        childs.push( /*#__PURE__*/React.cloneElement(children, {
          tabClick: _this.childClick,
          active: children.props.value == _this.state.activeValue,
          clsfix: clsfix
        }));
      }

      return childs;
    });

    _defineProperty(_assertThisInitialized(_this), "childClick", function (activeValue) {
      _this.setState({
        activeValue: activeValue
      });

      _this.props.onChange(activeValue);
    });

    _this.state = {
      activeValue: props.value
    };
    return _this;
  }

  _createClass(SearchTabs, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps && nextProps.value != this.state.activeValue) {
        this.setState({
          activeValue: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          clsfix = _this$props2.clsfix,
          children = _this$props2.children,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          others = _objectWithoutProperties(_this$props2, _excluded);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: "".concat(clsfix)
      }, others), this.getChildren());
    }
  }]);

  return SearchTabs;
}(Component);

;
SearchTabs.propTypes = propTypes;
SearchTabs.defaultProps = defaultProps;
export default SearchTabs;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/SearchTabs.js